


export default function DescriptionWithLogos(props) {


    return (
        <div>
            <div className="bg-gray-900 py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="grid grid-cols-1 items-center gap-x-8 gap-y-16 lg:grid-cols-2">
                        <div className="mx-auto w-full max-w-xl lg:mx-0">
                            <h2 className="text-3xl font-bold tracking-tight text-white">
                                Forged at world-class organizations
                            </h2>
                            <p className="mt-6 text-lg leading-8 text-gray-300">
                                With strategy, precision, and creativity, we help innovative teams dominate search results, attract the right audience, and turn visibility into measurable growth.
                            </p>
                            <div className="mt-8 flex items-end gap-x-6">

                                <div className="flex justify-end">
                                    <a
                                        href="/seo-retainer"
                                        type="button"
                                        className="mt-4 w-full rounded-full bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                                    >
                                        Explore Retainer
                                    </a>
                                </div>
                                <a href="/services" className="text-sm font-semibold text-white">
                                    Explore Products{" "}
                                    <span aria-hidden="true">&rarr;</span>
                                </a>
                            </div>
                        </div>
                        <div
                            className="mx-auto text-white custom-font grid w-full max-w-xl grid-cols-2 items-center gap-y-12 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:pl-8">
                            <div>
                                Shopify
                            </div>
                            <div>
                                Shopify Plus
                            </div>
                            <div>
                                WordPress
                            </div>
                            <div>
                                Drupal
                            </div>
                            <div>
                                Wix
                            </div>
                            <div>
                                Squarespace
                            </div>
                            <div>
                                BigCommerce
                            </div>
                            <div>
                                Custom Website
                            </div>
                            {/*<div className="text-red-500">*/}
                            {/*    MORE...*/}
                            {/*</div>*/}

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}